import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import { filter, take, takeUntil } from 'rxjs/operators';
import { Store } from '@ngrx/store';
import { CurrencyPipe, DatePipe, JsonPipe } from '@angular/common';
import { OrderWrapperComponent } from "../../component/wrapper/order-wrapper.component";
import { accountFeature } from '../../store/account.store';
import { getDigitalPurchases, GetDigitalPurchasesData, getReviewsForFulfillment, GetReviewsForFulfillmentData } from '@dataconnect/account';
import { LoadingLogoComponent } from "../../component/layout/element/loading-logo.component";

import { dateTimeFormat, Status } from '../../../../globalTypes/base.types';
import { NameTagComponent } from "../../component/layout/element/name.tag.component";
import { FileSizePipe } from '../../helper/filesize.pipe';
import { MatIconModule } from '@angular/material/icon';
import { HttpClient } from '@angular/common/http';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { Base } from '../../component/wrapper/base-wrapper.component';
import { MatSnackBar } from '@angular/material/snack-bar';
import { UPLOADED_FILES_FOLDER_NAME } from '../../../../globalTypes/file.types';
import { ButtonComponent } from "../../component/layout/element/button.component";
import { uiErrorCatcher } from '../../helper/error.handling';
import { createBlankReview, ReviewForEdit } from '../../../../globalTypes/review.types';
import { Fulfillment } from '../../../../globalTypes/fulfillment.types';
import { v4 as uuidV4 } from 'uuid';
import { Logger } from '../../helper/logger';
import { Functions } from '@angular/fire/functions';
import { ViewProductReviewDialogComponent } from '../../component/review/view.review.dialog';
import { EditProductReviewDialogComponent } from '../../component/review/edit.review.dialog';
import { MatDialog } from '@angular/material/dialog';
import { lastValueFrom } from 'rxjs';
import { httpsCallable, HttpsCallableResult } from 'firebase/functions';
import { onCallFunctions } from '../../../../globalTypes/backend.api.types';
import { LocationPrivate } from '../../../../globalTypes/account.types';
const log = new Logger("DigitalMaterial")

interface iListingVariation {
  id: string;
  name?: string;
  description?: string;
  image?: {
    url: string;
  }
  folderIds: string[];
}

interface iListing {
  id: string;
  name: string;
  description: string;
  variationIds: string[];
}

interface iDigitalFolder {
  id: string;
  folderName: string;
  parentId: string | null;
  itemIds: string[];
}

interface iDigitalPurchase {
  id: string;
  title: string;
  extension: string;
  sizeInBytes: number;
  displayOrder: number;
  updatedAt: string;
  purchaseId: string;
};

interface iFulfillment {
  id: string;
  fulfillmentNumber: number;
  fulfilledByLocationId: string;
  fulfillmentTotalAmount: number;
  statusId: string;
  listingIds: string[];
}

interface iOrder {
  orderNumber: number;
  id: string;
  fulfillmentIds: string[];
  createdAt: string;
}

@Component({
  selector: 'msh-files',
  imports: [OrderWrapperComponent, DatePipe, MatIconModule, FileSizePipe, CurrencyPipe, LoadingLogoComponent, NameTagComponent, ButtonComponent],
  template: `
  <msh-order-wrapper>
    <div class=" m-auto flex justify-center ">
      @if(!initComplete){
        <msh-loading-logo class=" w-96 h-96"></msh-loading-logo>
      } @else {
       @if(!purchases) { <div class="null">There are no fulfillment needs for this location</div> } @else {
        <div class="w-full mx-0 md:mx-12">
          @for(order of orders; track order.id){
            <div class="relative border-b border-navy/25 pt-8 px-6 rounded pb-8">
              <div class="md:flex gap-12">
                <div class="w-full">
                  <div class=" uppercase font-extrabold text-xl flex items-center gap-10">
                    <div (click)="goTo('order', order.id)" class=" hover:text-orange-500 cursor-pointer " >Order #{{order.orderNumber}}</div>
                    <div class=" text-sm mt-2 font-thin">
                        {{order.createdAt | date:dateTimeFormat}}
                    </div>
                  </div>
                  <div class="w-full">
                    @for(fulfillmentId of order.fulfillmentIds; track fulfillmentId){
                      @if(fulfillments[fulfillmentId]; as fulfillment){
                        <div class="flex mt-6" [id]="'fulfillment-' + fulfillment.fulfillmentNumber">
                          <div class="mb-0 uppercase font-thin">Fulfillment #{{fulfillment.fulfillmentNumber}} </div>
                          <div class="md:hidden flex flex-wrap">
                                <div class="mt-3">
                                  @if(locations && locations[fulfillment.fulfilledByLocationId]){
                                    <msh-name-tag
                                      [size]="'small'"
                                      [label]="locations[fulfillment.fulfilledByLocationId].name"
                                      [url]="locations[fulfillment.fulfilledByLocationId].profileImage?.url"
                                    ></msh-name-tag>
                                  }
                                </div>
                          </div>
                          <div class="grow">
                            @if(fulfillment.statusId === "downloadable"){
                              <msh-button cta="Write Review" (onClick)="openReviewDialog(fulfillment)"></msh-button>
                            }
                          </div>
                          <div class=" right-6 top-8  uppercase font-extrabold text-lg">{{fulfillment.fulfillmentTotalAmount | currency}}</div>

                        </div>
                        <div class=" ">
                          @for(listingId of fulfillment.listingIds; track listingId){
                            @if(listings[listingId+'_'+fulfillmentId]; as listing){
                              <div class="flex grow gap-2">
                                <div class="mb-2 font-bold">{{listing.name}}</div>
                                <div class="mb-2">{{listing.description}}</div>
                              </div>
                                @for(variationId of listing.variationIds; track variationId){
                              <div class="flex flex-wrap w-full mb-3 gap-3 ">
                                  @if(listingVariations[variationId]; as variation){
                                    <div class="flex grow"> 
                                    @if(variation.image && variation.image.url){
                                      <div 
                                        class="  w-16 h-16 bg-back flex justify-center items-center mr-6 rounded overflow-hidden bg-white"
                                      >
                                        <img [src]="variation.image.url" />
                                      </div>
                                    }
                                    @if(variation.name || variation.description){
                                      <div class="max-w-96">
                                          <div class="mb-2">{{variation.name}}</div>
                                          <div class="mb-2">{{variation.description}}</div>
                                      </div>
                                    }
                                    </div>
                                    <div class="ml-auto grow ">
                                      @for(folderId of variation.folderIds; track folderId){
                                        @if(folders[folderId]; as folder){
                                            <div [class]="'mb-2 flex items-center gap-2 ' + (folder.parentId ? 'ml-4' : '')">
                                              <mat-icon>folder</mat-icon>
                                              {{folder.folderName !== UPLOADED_FILES_FOLDER_NAME ? folder.folderName : 'Downloadable Files'}}
                                            </div>
                                            @for(digitalItemId of folder.itemIds; track digitalItemId){
                                              @if(digitalItems[digitalItemId]; as item){
                                                <div [class]="'flex gap-2 cursor-pointer hover:text-orange-500 ' + (folder.parentId ? 'ml-8' : ' ml-4')" (click)="downloadPurchase(item.purchaseId, item.title, item.extension)">
                                                  <mat-icon>description</mat-icon>
                                                  <div>
                                                    <div class="">{{item.title}}{{item.extension ? "." + item.extension : ''}}</div>
                                                    <div class="flex gap-2 mb-2 text-sm opacity-50 ">
                                                      <div>{{item.sizeInBytes | filesize }}</div>
                                                      <div>&bull;</div>
                                                      <div>{{item.updatedAt | date: dateTimeFormat}}</div>
                                                    </div>
                                                  </div>
                                                </div>
                                              }
                                            }
                                        }
                                      }
                                    </div>
                                  }
                              </div>
                                }
                            }
                          }
                        </div>
                      }
                    }
                  </div>
                  
                </div>
              </div>

            </div>
          }
        </div>
       }
      } 
    </div>
  </msh-order-wrapper>
  `
})
export class DigitalMaterialComponent extends Base<DigitalMaterialComponent>{

  purchases: any[] = [];
  locations: any = {};
  location: LocationPrivate | null = null;
  initComplete = false;
  dateTimeFormat = dateTimeFormat;
  orders: iOrder[] = [];
  fulfillments: { [key: string]: iFulfillment } = {};
  listingVariations: { [key: string]: iListingVariation } = {};
  listings: { [key: string]: iListing } = {};
  digitalItems: { [key: string]: iDigitalPurchase } = {};
  folders: { [key: string]: iDigitalFolder } = {};
  UPLOADED_FILES_FOLDER_NAME = UPLOADED_FILES_FOLDER_NAME;

  constructor(
    private store: Store,
    private http: HttpClient,
    private router: Router,
    private route: ActivatedRoute,
    private snackBar: MatSnackBar,
    private dialog: MatDialog,
    private functions: Functions
  ) {
    super();
    this.store.select(accountFeature.selectLocation).pipe(filter(location => !!location)).subscribe(async location => {
      console.log(location);
      this.location = location;
      const purchaseRef = await getDigitalPurchases({ locationId: location.id });
      const purchaseData: GetDigitalPurchasesData = purchaseRef.data;
      this.purchases = [...purchaseData.digitalPurchases]
      console.log({purchaseData: this.purchases})
      purchaseData.digitalPurchases.forEach((p: GetDigitalPurchasesData["digitalPurchases"][0]) => {
        if(!p.digitalItem || !p.digitalItem.id || !p.digitalItem.folder || !p.listingVariation || !p.fulfillment ) return;
        const { fulfilledByLocationId, order , fulfillmentTotalAmount, statusId: fulfillmentStatus, fulfillmentNumber, id: fulfillmentId } = p.fulfillment
        let { id: digitalItemId, folder, title, extension, sizeInBytes, displayOrder, updatedAt } = p.digitalItem ;
        if(extension && (title || '').endsWith(`.${extension}`)) {
          extension = '';
        }
        let { id: folderId, parentId, folderName } = folder
        folderId = folderId+"_"+fulfillmentId;
      
        let {id: variationId, name: variationName, description: variationDescription, image, listing} = p.listingVariation
        const {id: listingId, name: listingName, description: listingDescription} = listing || {id: '', name: '', description: ''};
        variationId = variationId+"_"+fulfillmentId;
        // store digital item information
        this.digitalItems[digitalItemId] = { id: digitalItemId, purchaseId: p.id, title: title || '', extension: extension || '', sizeInBytes: sizeInBytes || 0, displayOrder: displayOrder || 0, updatedAt: updatedAt || '' };
        // store listing variation information
        if(!this.listingVariations[variationId]) {
          this.listingVariations[variationId] = {id: variationId, name: variationName, image, description: variationDescription || '', folderIds: []};
        }
        // store folder information
        if(!this.folders[folderId]) {
          this.folders[folderId] = {id: folderId, folderName: folderName || '', parentId: parentId || '', itemIds: []};
        }
        this.folders[folderId].itemIds.push(digitalItemId);
        const existingFolders = this.listingVariations[variationId].folderIds.filter(id => id !== folderId);
        this.listingVariations[variationId].folderIds = [...existingFolders, folderId];
        // store listing information
        if(!this.listings[listingId+'_'+fulfillmentId]) {
          this.listings[listingId+'_'+fulfillmentId] = {id: listingId, name: listingName, description: listingDescription || '', variationIds: []};
        }
        const existingVariations = this.listings[listingId+'_'+fulfillmentId].variationIds.filter(id => id !== variationId);
        this.listings[listingId+'_'+fulfillmentId].variationIds = [...existingVariations, variationId];
        // store fulfillment information
        if(!this.fulfillments[fulfillmentId]) {
          this.fulfillments[fulfillmentId] = { 
            fulfilledByLocationId: fulfilledByLocationId || '', 
            fulfillmentTotalAmount: (fulfillmentTotalAmount || 0)/100, 
            fulfillmentNumber: fulfillmentNumber || 0, 
            statusId: fulfillmentStatus || '',
            id: fulfillmentId, listingIds: [] };
        }
        const existingListings = this.fulfillments[fulfillmentId].listingIds.filter(id => id !== listingId);
        this.fulfillments[fulfillmentId].listingIds = [...existingListings, listingId];
        // store order information
        const existingOrderId = this.orders.findIndex(o => o.id === order.id);
        if(existingOrderId > -1) {
          const existingFulfillmentIds = this.orders[existingOrderId].fulfillmentIds.filter(id => id !== fulfillmentId);
          this.orders[existingOrderId].fulfillmentIds = [...existingFulfillmentIds, fulfillmentId];
        }else{
          this.orders.push({ id: order.id, createdAt: order.createdAt || '', fulfillmentIds: [fulfillmentId], orderNumber: order.orderNumber || 0 });
        }
        setTimeout(() => {
          const fulfillmentNumber = this.route.snapshot.queryParams['fulfillment'];
          console.log({fulfillmentNumber})
          if(fulfillmentNumber){
            const element = document.getElementById(`fulfillment-${fulfillmentNumber}`);
            if(element) {
              element.scrollIntoView({ behavior: 'smooth' });
            }
          }
        },0);
      });
      this.initComplete = true;

    });
    // [ ] Fetch and store location data for each purchase
    // [ ] Add download purchase functionality
  }


  async openReviewDialog(fulfillment: iFulfillment){
    // get review
    if(!fulfillment) return;
    let review: ReviewForEdit | GetReviewsForFulfillmentData['reviews'][0] | null = null;
    const reviewsRef = await getReviewsForFulfillment({fulfillmentId: fulfillment?.id || ''});
    review = reviewsRef.data.reviews.find(r => r.fulfillment?.id === fulfillment?.id && r.isBuyer) || null;
    if(!review){
      const id = uuidV4()
      review = createBlankReview(id, fulfillment as unknown as Pick<Fulfillment, 'id' | 'statusId' | 'fulfilledToLocationId' | 'fulfilledByLocationId'>)
    }
    if(!review) return;
    review.fulfillment = {id: fulfillment.id } as Fulfillment;
    review.reviewById = this.location ? this.location.id || '' : '';
    review.reviewForId = fulfillment.fulfilledByLocationId || '';
    const dialogComponent = EditProductReviewDialogComponent;
    const dialog = this.dialog.open(dialogComponent, {data: {review}});
    const updatedReview = await lastValueFrom(dialog.afterClosed().pipe(take(1)));
    if(updatedReview){
      const callable = httpsCallable(this.functions,  onCallFunctions.submitReview);
      try {
        const results: HttpsCallableResult = await uiErrorCatcher(callable({review: updatedReview}), this.snackBar, "Error submitting review") 
        console.log({results})
        // change fulfillment status to something
        this.snackBar.open("Review submitted successfully", "close", {duration: 3000});
      } catch(error){
        log.error("Error submitting review", error)
      }
    }
  }

  goTo(type: string, id: string){
    if(type === 'order'){
      this.router.navigate(['/order','purchase', id]);
    }
  }

  downloadPurchase(digitalPurchaseId: string, title: string, ext?: string) {
    this.http.get(`/digitalDownloadFile/${digitalPurchaseId}`, { responseType: 'blob' })
      .subscribe(blob => {
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        if(ext && title.endsWith(`.${ext}`)) {
          ext = '';
        }
        const fileName = `${title}${ext ? '.' + ext : ''}`; 
        a.download = fileName;
        a.click();
        window.URL.revokeObjectURL(url);
        this.snackBar.open('Downloading ' + title, 'Close', { duration: 3000 });
      });
  }
}
